/* eslint-disable no-undef */
/*
 * @file: index.js
 * @description: It Contain environment variables.
 * @date: 26-09-2024
 * @author: Maheshvar
 */

//For local setup
const local = {
    apiUrl: 'http://localhost:', //local
    landinPageUrl: 'http://localhost:8081',
    referuspageurl: 'http://localhost:8081',
    paymentUrl: `https://app.moonclerk.com/pay/kjra99498ml`,
    version: '/api/v1',
    PORT: '4002',
};


//For pre-prod setup
const preprod = {
    apiUrl: 'http://localhost:', //pre-prod
    PORT: '4002',
};

//For dev server
const dev = {
    apiUrl: 'http://54.215.36.15:',
    // landinPageUrl: 'https://ss.stagingsdei.com:3380',
    // referuspageurl: 'https://ss.stagingsdei.com:3380',
    landinPageUrl: 'http://localhost:8081',
    referuspageurl: 'http://localhost:8081',
    version: '/api/v1',
    PORT: '4002',
};

//For production server
const production = {
    apiUrl: 'https://api.referusnetwork.com',
    landinPageUrl: 'https://referusnetwork.com',
    referuspageurl: 'https://cms.referusnetwork.com',
    version: '/api/v1',
    PORT: '',
};

//For staging server port KEY can not be remove its using in application
const staging = {
    apiUrl: 'https://ss.stagingsdei.com:',
    landinPageUrl: 'https://ss.stagingsdei.com:3380',
    referuspageurl:'https://ss.stagingsdei.com:3380',
    version: '/api/v1',
    PORT: '3384',
};

if (process.env.NODE_ENV === 'development') module.exports = local;
else if (process.env.NODE_ENV === 'dev') module.exports = dev;
else if (process.env.NODE_ENV === 'none') module.exports = staging;
else if (process.env.NODE_ENV === 'preprod') module.exports = preprod;
else if (process.env.NODE_ENV === 'production') module.exports = production;
else module.exports = local;
